import { store } from 'redux/store';
import { Partner } from 'types';
import { addDocumentToPartner } from 'modules/partners/api/addDocumentToPartner';

type UpdatePartnerDocumentsProps = {
  partner: Partner;
  newDocumentId: string;
};

export const updatePartnerDocuments = async ({
  partner,
  newDocumentId,
}: UpdatePartnerDocumentsProps) => {
  if (newDocumentId) {
    await store.dispatch(
      addDocumentToPartner({
        partnerId: partner._id,
        documentId: newDocumentId,
      })
    );
  }
};
